/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Skillgroups1Inputs */

const en_nav_skillgroups1 = /** @type {(inputs: Nav_Skillgroups1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill Groups`)
};

const de_nav_skillgroups1 = /** @type {(inputs: Nav_Skillgroups1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skillgruppen`)
};

/**
* | output |
* | --- |
* | "Skill Groups" |
*
* @param {Nav_Skillgroups1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nav_skillgroups1 = /** @type {((inputs?: Nav_Skillgroups1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Skillgroups1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_skillgroups1(inputs)
	return de_nav_skillgroups1(inputs)
});
export { nav_skillgroups1 as "nav_skillGroups" }